import * as React from "react";

const MockQRCode = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={props.width || 696}
    height={props.height || 696}
    viewBox="0 0 696 696"
    {...props}
  >
    <path fill="#fff" d="M0 0h696v696H0z" />
    <path d="M288 48h24.72v24.72H288zM360 48h24.72v24.72H360zM432 48h24.72v24.72H432z" />
    <path d="M264 72h24.72v24.72H264zM312 72h24.72v24.72H312z" />
    <path d="M336 72h24.72v24.72H336zM408 72h24.72v24.72H408zM240 96h24.72v24.72H240z" />
    <path d="M264 96h24.72v24.72H264zM384 96h24.72v24.72H384z" />
    <path d="M408 96h24.72v24.72H408z" />
    <path d="M432 96h24.72v24.72H432zM240 120h24.72v24.72H240z" />
    <path d="M264 120h24.72v24.72H264zM312 120h24.72v24.72H312z" />
    <path d="M336 120h24.72v24.72H336z" />
    <path d="M360 120h24.72v24.72H360z" />
    <path d="M384 120h24.72v24.72H384zM240 144h24.72v24.72H240z" />
    <path d="M264 144h24.72v24.72H264z" />
    <path d="M288 144h24.72v24.72H288z" />
    <path d="M312 144h24.72v24.72H312zM384 144h24.72v24.72H384zM432 144h24.72v24.72H432zM240 168h24.72v24.72H240z" />
    <path d="M264 168h24.72v24.72H264zM312 168h24.72v24.72H312z" />
    <path d="M336 168h24.72v24.72H336z" />
    <path d="M360 168h24.72v24.72H360z" />
    <path d="M384 168h24.72v24.72H384z" />
    <path d="M408 168h24.72v24.72H408zM240 192h24.72v24.72H240zM288 192h24.72v24.72H288zM336 192h24.72v24.72H336z" />
    <path d="M384 192h24.72v24.72H384zM432 192h24.72v24.72H432zM240 216h24.72v24.72H240zM288 216h24.72v24.72H288z" />
    <path d="M432 216h24.72v24.72H432zM48 240h24.72v24.72H48zM96 240h24.72v24.72H96z" />
    <path d="M120 240h24.72v24.72H120z" />
    <path d="M144 240h24.72v24.72H144z" />
    <path d="M168 240h24.72v24.72H168z" />
    <path d="M192 240h24.72v24.72H192zM264 240h24.72v24.72H264z" />
    <path d="M288 240h24.72v24.72H288zM336 240h24.72v24.72H336z" />
    <path d="M360 240h24.72v24.72H360z" />
    <path d="M384 240h24.72v24.72H384zM480 240h24.72v24.72H480z" />
    <path d="M504 240h24.72v24.72H504z" />
    <path d="M528 240h24.72v24.72H528z" />
    <path d="M552 240h24.72v24.72H552z" />
    <path d="M576 240h24.72v24.72H576zM72 264h24.72v24.72H72zM120 264h24.72v24.72H120z" />
    <path d="M144 264h24.72v24.72H144z" />
    <path d="M168 264h24.72v24.72H168zM240 264h24.72v24.72H240z" />
    <path d="M264 264h24.72v24.72H264zM312 264h24.72v24.72H312z" />
    <path d="M336 264h24.72v24.72H336zM456 264h24.72v24.72H456zM504 264h24.72v24.72H504zM600 264h24.72v24.72H600zM48 288h24.72v24.72H48zM144 288h24.72v24.72H144zM192 288h24.72v24.72H192z" />
    <path d="M216 288h24.72v24.72H216zM264 288h24.72v24.72H264z" />
    <path d="M288 288h24.72v24.72H288zM336 288h24.72v24.72H336zM384 288h24.72v24.72H384z" />
    <path d="M408 288h24.72v24.72H408zM456 288h24.72v24.72H456z" />
    <path d="M480 288h24.72v24.72H480zM552 288h24.72v24.72H552zM600 288h24.72v24.72H600z" />
    <path d="M624 288h24.72v24.72H624zM72 312h24.72v24.72H72z" />
    <path d="M96 312h24.72v24.72H96zM144 312h24.72v24.72H144zM288 312h24.72v24.72H288zM336 312h24.72v24.72H336zM384 312h24.72v24.72H384z" />
    <path d="M408 312h24.72v24.72H408zM456 312h24.72v24.72H456z" />
    <path d="M480 312h24.72v24.72H480zM624 312h24.72v24.72H624zM72 336h24.72v24.72H72z" />
    <path d="M96 336h24.72v24.72H96z" />
    <path d="M120 336h24.72v24.72H120zM192 336h24.72v24.72H192z" />
    <path d="M216 336h24.72v24.72H216z" />
    <path d="M240 336h24.72v24.72H240zM312 336h24.72v24.72H312zM408 336h24.72v24.72H408z" />
    <path d="M432 336h24.72v24.72H432z" />
    <path d="M456 336h24.72v24.72H456z" />
    <path d="M480 336h24.72v24.72H480z" />
    <path d="M504 336h24.72v24.72H504z" />
    <path d="M528 336h24.72v24.72H528zM576 336h24.72v24.72H576z" />
    <path d="M600 336h24.72v24.72H600z" />
    <path d="M624 336h24.72v24.72H624zM48 360h24.72v24.72H48zM216 360h24.72v24.72H216z" />
    <path d="M240 360h24.72v24.72H240zM336 360h24.72v24.72H336z" />
    <path d="M360 360h24.72v24.72H360zM432 360h24.72v24.72H432zM504 360h24.72v24.72H504zM552 360h24.72v24.72H552zM600 360h24.72v24.72H600zM48 384h24.72v24.72H48zM120 384h24.72v24.72H120z" />
    <path d="M144 384h24.72v24.72H144z" />
    <path d="M168 384h24.72v24.72H168z" />
    <path d="M192 384h24.72v24.72H192z" />
    <path d="M216 384h24.72v24.72H216z" />
    <path d="M240 384h24.72v24.72H240z" />
    <path d="M264 384h24.72v24.72H264z" />
    <path d="M288 384h24.72v24.72H288zM360 384h24.72v24.72H360z" />
    <path d="M384 384h24.72v24.72H384z" />
    <path d="M408 384h24.72v24.72H408z" />
    <path d="M432 384h24.72v24.72H432z" />
    <path d="M456 384h24.72v24.72H456zM504 384h24.72v24.72H504z" />
    <path d="M528 384h24.72v24.72H528z" />
    <path d="M552 384h24.72v24.72H552zM600 384h24.72v24.72H600z" />
    <path d="M624 384h24.72v24.72H624zM48 408h24.72v24.72H48zM120 408h24.72v24.72H120zM168 408h24.72v24.72H168zM240 408h24.72v24.72H240z" />
    <path d="M264 408h24.72v24.72H264zM336 408h24.72v24.72H336z" />
    <path d="M360 408h24.72v24.72H360zM408 408h24.72v24.72H408z" />
    <path d="M432 408h24.72v24.72H432zM504 408h24.72v24.72H504z" />
    <path d="M528 408h24.72v24.72H528zM624 408h24.72v24.72H624zM48 432h24.72v24.72H48zM96 432h24.72v24.72H96z" />
    <path d="M120 432h24.72v24.72H120zM168 432h24.72v24.72H168z" />
    <path d="M192 432h24.72v24.72H192zM240 432h24.72v24.72H240zM288 432h24.72v24.72H288zM336 432h24.72v24.72H336zM384 432h24.72v24.72H384z" />
    <path d="M408 432h24.72v24.72H408z" />
    <path d="M432 432h24.72v24.72H432z" />
    <path d="M456 432h24.72v24.72H456z" />
    <path d="M480 432h24.72v24.72H480z" />
    <path d="M504 432h24.72v24.72H504z" />
    <path d="M528 432h24.72v24.72H528zM576 432h24.72v24.72H576zM240 456h24.72v24.72H240z" />
    <path d="M264 456h24.72v24.72H264z" />
    <path d="M288 456h24.72v24.72H288zM432 456h24.72v24.72H432zM528 456h24.72v24.72H528z" />
    <path d="M552 456h24.72v24.72H552zM264 480h24.72v24.72H264z" />
    <path d="M288 480h24.72v24.72H288z" />
    <path d="M312 480h24.72v24.72H312z" />
    <path d="M336 480h24.72v24.72H336zM432 480h24.72v24.72H432zM480 480h24.72v24.72H480zM528 480h24.72v24.72H528zM576 480h24.72v24.72H576z" />
    <path d="M600 480h24.72v24.72H600z" />
    <path d="M624 480h24.72v24.72H624zM240 504h24.72v24.72H240z" />
    <path d="M264 504h24.72v24.72H264z" />
    <path d="M288 504h24.72v24.72H288z" />
    <path d="M312 504h24.72v24.72H312zM384 504h24.72v24.72H384zM432 504h24.72v24.72H432zM528 504h24.72v24.72H528z" />
    <path d="M552 504h24.72v24.72H552zM624 504h24.72v24.72H624zM240 528h24.72v24.72H240zM288 528h24.72v24.72H288z" />
    <path d="M312 528h24.72v24.72H312zM408 528h24.72v24.72H408z" />
    <path d="M432 528h24.72v24.72H432z" />
    <path d="M456 528h24.72v24.72H456z" />
    <path d="M480 528h24.72v24.72H480z" />
    <path d="M504 528h24.72v24.72H504z" />
    <path d="M528 528h24.72v24.72H528zM576 528h24.72v24.72H576z" />
    <path d="M600 528h24.72v24.72H600z" />
    <path d="M624 528h24.72v24.72H624zM240 552h24.72v24.72H240zM288 552h24.72v24.72H288zM336 552h24.72v24.72H336z" />
    <path d="M360 552h24.72v24.72H360z" />
    <path d="M384 552h24.72v24.72H384z" />
    <path d="M408 552h24.72v24.72H408zM456 552h24.72v24.72H456z" />
    <path d="M480 552h24.72v24.72H480zM528 552h24.72v24.72H528z" />
    <path d="M552 552h24.72v24.72H552z" />
    <path d="M576 552h24.72v24.72H576z" />
    <path d="M600 552h24.72v24.72H600z" />
    <path d="M624 552h24.72v24.72H624zM240 576h24.72v24.72H240z" />
    <path d="M264 576h24.72v24.72H264zM360 576h24.72v24.72H360z" />
    <path d="M384 576h24.72v24.72H384z" />
    <path d="M408 576h24.72v24.72H408z" />
    <path d="M432 576h24.72v24.72H432zM552 576h24.72v24.72H552z" />
    <path d="M576 576h24.72v24.72H576zM624 576h24.72v24.72H624zM336 600h24.72v24.72H336z" />
    <path d="M360 600h24.72v24.72H360zM408 600h24.72v24.72H408z" />
    <path d="M432 600h24.72v24.72H432zM480 600h24.72v24.72H480z" />
    <path d="M504 600h24.72v24.72H504z" />
    <path d="M528 600h24.72v24.72H528z" />
    <path d="M552 600h24.72v24.72H552zM624 600h24.72v24.72H624zM240 624h24.72v24.72H240zM288 624h24.72v24.72H288zM336 624h24.72v24.72H336zM384 624h24.72v24.72H384zM456 624h24.72v24.72H456zM504 624h24.72v24.72H504z" />
    <path d="M528 624h24.72v24.72H528z" />
    <path d="M552 624h24.72v24.72H552z" />
    <path d="M576 624h24.72v24.72H576z" />
    <path d="M600 624h24.72v24.72H600z" />
    <path d="M624 624h24.72v24.72H624zM48 48v168h168V48H48zm144 144H72V72h120v120zM480 48v168h168V48H480zm144 144H504V72h120v120zM48 480v168h168V480H48zm144 144H72V504h120v120z" />
    <path d="M96 96h72v72H96zM528 96h72v72h-72zM96 528h72v72H96z" />
  </svg>
);

export default MockQRCode;
